module.exports = __webpack_public_path__ + "img/calender.d1f9aaa3.svg";